import { atom } from 'recoil';

const generateSessionId = () => {
  return crypto.randomUUID();
};

export const initialBookingSessionState = {
  sessionId: generateSessionId(),
};

const bookingSessionState = atom({
  key: 'bookingSession',
  default: initialBookingSessionState,
});

export default bookingSessionState;
